
import * as defaultImport from "@splunk/react-search/components/Input";
export * from "@splunk/react-search/components/Input";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
